import { createWebEnjoyApp } from "./web-adapter";

const enjoyApp = createWebEnjoyApp();

if (!window.__ENJOY_APP__) {
  try {
    window.__ENJOY_APP__ = enjoyApp;
    window.EnjoyApp = enjoyApp;
  } catch {
    Object.defineProperty(window, '__ENJOY_APP__', {
      value: enjoyApp,
      writable: true,
      configurable: true,
    });
    Object.defineProperty(window, 'EnjoyApp', {
      value: enjoyApp,
      writable: true,
      configurable: true,
    });
  }
  
  (globalThis as any).EnjoyApp = enjoyApp;
}

declare global {
  interface Window {
    __ENJOY_APP__: EnjoyAppType;
    EnjoyApp: EnjoyAppType;
  }
  var EnjoyApp: EnjoyAppType;
}

export { enjoyApp };
